import { render, staticRenderFns } from "./EstudianteImportacionRegistro.vue?vue&type=template&id=48f4c5f0&scoped=true"
import script from "./EstudianteImportacionRegistro.vue?vue&type=script&lang=js"
export * from "./EstudianteImportacionRegistro.vue?vue&type=script&lang=js"
import style0 from "./EstudianteImportacionRegistro.vue?vue&type=style&index=0&id=48f4c5f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f4c5f0",
  null
  
)

export default component.exports